import { isTeamChannel, ModerationType } from "../const/ModerationTypes";
import { WorkOptions } from "../const/WorkOptions";

type TeamActionsLike = {
    moderationType?: number | null;
    isServiceTeam?: boolean;
    fieldOfActivity?: number | null;
    parentTeamId?: string | null;
};

/** Канал: enum закомментирован, в API это 7. */
const CHANNEL_MODERATION_TYPE = 7;

const EXCLUDED_MODERATION_TYPES: number[] = [
    ModerationType.Default, // 0 — витрины «По умолчанию»
    ModerationType.LMS,     // 3 — свои учебные курсы
    CHANNEL_MODERATION_TYPE,
];

export const JOINABLE_TEAM_TYPES: ModerationType[] = [
    ModerationType.Own,
    ModerationType.OwnWithoutTag,
    ModerationType.Outer,
];

export const shouldShowTeamPublicActionsMenu = (team?: TeamActionsLike | null): boolean => {
    if (!team) return false;

    const type = (team.moderationType ?? ModerationType.Default) as number;

    if (EXCLUDED_MODERATION_TYPES.includes(type)) return false;
    if (isTeamChannel(type as ModerationType).isChannel) return false;
    if (team.isServiceTeam) return false;
    if (team.fieldOfActivity === WorkOptions.TechnicalOrganization) return false;

    return true;
};

export const isTeamJoinable = (team?: { moderationType?: number | null } | null): boolean => {
    if (!team) return false;
    return JOINABLE_TEAM_TYPES.includes((team.moderationType ?? ModerationType.Default) as ModerationType);
};
import { isTeamChannel, ModerationType } from "../const/ModerationTypes";
import { WorkOptions } from "../const/WorkOptions";

type TeamActionsLike = {
    moderationType?: number | null;
    isServiceTeam?: boolean;
    fieldOfActivity?: number | null;
    parentTeamId?: string | null;
};

/** Канал: enum закомментирован, в API это 7. */
const CHANNEL_MODERATION_TYPE = 7;

const EXCLUDED_MODERATION_TYPES: number[] = [
    ModerationType.Default, // 0 — витрины «По умолчанию»
    ModerationType.LMS,     // 3 — свои учебные курсы
    CHANNEL_MODERATION_TYPE,
];

export const JOINABLE_TEAM_TYPES: ModerationType[] = [
    ModerationType.Own,
    ModerationType.OwnWithoutTag,
    ModerationType.Outer,
];

export const shouldShowTeamPublicActionsMenu = (team?: TeamActionsLike | null): boolean => {
    if (!team) return false;

    const type = (team.moderationType ?? ModerationType.Default) as number;

    if (EXCLUDED_MODERATION_TYPES.includes(type)) return false;
    if (isTeamChannel(type as ModerationType).isChannel) return false;
    if (team.isServiceTeam) return false;
    if (team.fieldOfActivity === WorkOptions.TechnicalOrganization) return false;

    return true;
};

export const isTeamJoinable = (team?: { moderationType?: number | null } | null): boolean => {
    if (!team) return false;
    return JOINABLE_TEAM_TYPES.includes((team.moderationType ?? ModerationType.Default) as ModerationType);
};
